import React from "react";
import Table from "../Common/Table";
import TableFields from "../../constants/RiderTdsCertificates/TableFields.json";
import { getPath } from "../../utils";

const TdsCertificatesList = ({ list }) => {
  const getFieldValue = (field, key) => {
    console.log(field, key, field["url"]);
    switch (key) {
      case "action":
        return (
          <span
            onClick={() => window.open(field["url"])}
            className={"edit-options cursor-pointer"}
          >
            Download
          </span>
        );
      default:
        return getPath(field, key, "NA");
    }
  };

  return (
    <Table list={list} getFieldValue={getFieldValue} fields={TableFields} />
  );
};

export default TdsCertificatesList;
